module.exports = __webpack_public_path__ + "img/20190522111807微信截图_20190522111949.cb5b2e67.png";